/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const AutoEndpoint = {
  Responses: "responses",
  Completions: "completions",
  Embeddings: "embeddings",
  Images: "images",
  Transcriptions: "transcriptions",
  Tts: "tts",
} as const;
export type AutoEndpoint = ClosedEnum<typeof AutoEndpoint>;

/** @internal */
export const AutoEndpoint$inboundSchema: z.ZodNativeEnum<typeof AutoEndpoint> =
  z.nativeEnum(AutoEndpoint);
/** @internal */
export const AutoEndpoint$outboundSchema: z.ZodNativeEnum<typeof AutoEndpoint> =
  AutoEndpoint$inboundSchema;
